module.exports = __webpack_public_path__ + "media/assets/community/resource-2-e91d7fc629f10f9c215bb90cadc21f13b52ab993c74faddf88afdc3a8b067433.png";